<template>
    <div class="checkbox-wrap" :class="{'dark-bg p-dark-bg': darkBg}">
      <input type="checkbox" :id="id" :checked="value" :disabled="disabled" @click="$emit('onUpdate', $event)">
      <label :for="id" :class="{'disabled': disabled}">
        {{ label }}
      </label>
    </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String
    },
    id: {
      type: String
    },
    darkBg: {
      type: Boolean
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../sass/variables'

.checkbox-wrap
  display: flex
  align-items: center
  input
    -webkit-appearance: none
    width: 20px
    height: 20px
    border: 1px solid $blue
    box-shadow: 0 2px 4px 0 rgba(0,0,102,0.3)
    background-color: white
    display: flex
    align-items: center
    justify-content: center
    &:checked
     &:after
        content: ''
        background-image: url('../assets/images/check-blue.svg')
        width: 12px
        height: 10px
        background-size: 100%
        background-repeat: no-repeat
    &:hover
      border-color: $red
      &:checked
        &:after
          background-image: url('../assets/images/check-red.svg')
    &:disabled
      color: $border-grey
      border: 1px solid $border-grey
      pointer-events: none
  label
    margin-left: 0.5em
  .disabled
    color: $border-grey
    pointer-events: none
.checkbox-wrap.p-dark-bg
  input
    border-color: white
    background: none
    opacity: 0.7
    &:checked
      &:after
       opacity: 0.7
       background: url('../assets/images/check-white.svg') no-repeat
    &:hover
      opacity: 1
      border-color: white
      &:checked
        &:after
         opacity: 1
         background: url('../assets/images/check-white.svg') no-repeat
  label
    color: white
    opacity: 0.7
    &:hover
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/Checkbox.vue